import React, { useCallback, useEffect } from 'react'
import styled from 'styled-components'
import { theme } from 'styled-tools'
import QuestionBlock from './QuestionBlock'

const QuestionBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${theme('colors.link')};
  font-size: 14px;
  @media (min-width: 720px) {
    font-size: 16px;
  }
  margin-top: 30px;
`

/**
 * @param {{
 *  questions: any[],
 *  updateUiState: (params: any[]) => any,
 *  prepData: any,
 *  onChange: (data: any) => void
 *  onLoading: () => void
 * }} params
 */
const QuickQuestions = ({
  questions,
  updateUiState,
  prepData,
  onChange,
  onLoading,
}) => {
  const onUpdate = useCallback(
    (id, questionText, value) => {
      const prepQuestions = prepData.questions || []
      const updatedQuestion = {
        id,
        question: questionText,
        answers: value,
      }

      const index = prepQuestions.findIndex(
        (p) => p.id === id || p.question === questionText
      )
      const updatedQuestions =
        index === -1
          ? [...prepQuestions, updatedQuestion]
          : [
              ...prepQuestions.slice(0, index),
              updatedQuestion,
              ...prepQuestions.slice(index + 1),
            ]
      const updatedPrepData = { ...prepData, questions: updatedQuestions }
      updateUiState({
        prepData: updatedPrepData,
      })
      onChange(updatedPrepData)
    },
    [onChange, updateUiState, prepData]
  )

  useEffect(() => {
    if (!questions?.length) {
      return;
    }
    if (!prepData?.questions?.length) {
      onChange(prepData)
    }
  }, [prepData, questions])

  return (
    <QuestionBlockWrapper data-track="questions">
      {questions?.map((question) => {
        const sortOrder = questions.findIndex(
          (q) =>
            q.questionText === question.questionText || q.id === question.id
        )
        const answers =
          prepData.questions.find(
            (q) => q.question === question.questionText || q.id === question.id
          )?.answers || []

        return (
          <QuestionBlock
            key={question.questionText}
            question={{ ...question, sortOrder }}
            answers={answers}
            onLoading={onLoading}
            onUpdate={(value) =>
              onUpdate(question.id, question.questionText, value)
            }
          />
        )
      })}
    </QuestionBlockWrapper>
  )
}

export default QuickQuestions
